import { apiCall, ApiConfig } from '../../config/api'
import { TypeConfiguration } from '../../interfaces/Configuration/Configuration'
import { getTypeConfigurationAction } from '../actions/typeConfigurationActions'
import { call, put, takeEvery } from '@redux-saga/core/effects'
import { AxiosError, AxiosResponse } from 'axios'
import { GET_TYPE_CONFIGURATION } from '../types/typeConfigurationtActionsTypes'

export function* getTypesConfigurationAsync() {
  try {
    const { status, data }: AxiosResponse<TypeConfiguration[]> = yield call(
      apiCall,
      'GET',
      `${ApiConfig.TypeConfigurationApi}/Get`
    )
    if (status === 200) {
      yield put(getTypeConfigurationAction(data))
    }
  } catch (error) {
    const serverError = error as AxiosError<string>
    yield put(getTypeConfigurationAction([], serverError.message))
  }
}

export function* watchGetTypesConfigurationAsync() {
  yield takeEvery(GET_TYPE_CONFIGURATION, getTypesConfigurationAsync)
}
